import "./Dashboard.css";
import BarChartSample from "../Components/Barcharts";
import HalfDonutTarget from "../Components/Monthlytraget";
import FullPieChart from "../Components/Categories";
import Orders from "./Orders";
import Ratereviewbox from "../Components/Ratereviewbox";
import Cards from "../Components/Cards";

const Vendordashboard = ({ orders, dashboard }) => {
  return (
    <div style={{ padding: "0 0 2rem 0" }}>
      <h1 className="dashboard-heading">Dashboard</h1>
      {/* First row */}
      <div className="dashboard-container">
        {/* Left Main Area */}
        <div className="main-area">
          {/* Top 4 Cards */}
          <Cards cards={dashboard?.Cards} />
          {/* Pie Chart and Monthly Target (2 cols) */}
          <div className="card-row">
            <div className="card large">
              <h2 className="chart-heading">Revenue Analytics</h2>
              <BarChartSample month={dashboard?.MonthWise} />
            </div>

            <div className="card large1">
              <h2 className="chart-heading">Monthly Target</h2>
              <HalfDonutTarget month={dashboard?.MonthWise} />
            </div>
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="sidebar1">
          <div className="card tall">
            <FullPieChart
              category={dashboard?.Category}
              product={dashboard?.ProductWise}
            />{" "}
          </div>
        </div>
      </div>

      {/* second row */}
      <div className="dashboard-container">
        {/* reports  */}
        <div className="main-area">
          <Orders orders={orders} />
        </div>

        {/* rate and reviews */}
        <div className="sidebar1">
          <Ratereviewbox review={dashboard?.Review} />
        </div>
      </div>
    </div>
  );
};

export default Vendordashboard;
